import request from '../request'

// 查询当前登录用户的审批任务列表
export function fetchTask(data) {
    return request({
        url: '/activiti-service/servicetask/user/tasks',
        data,
        method: 'POST'
    })
}

export function doneBatch(data) {
    return request({
        url: '/activiti-service/servicetask/tasks/complete',
        data,
        method: 'POST'
    })
}

// 查询审批任务详情的历史纪录和当前任务的信息
export function fetchTaskDetail(data) {
    return request({
        url: '/activiti-service/servicetask/task/index',
        data,
        method: 'POST'
    })
}

// 替换url
export function replaceUrl(data) {
    return request({
        url: '/common-service/file/transUrl/String/front',
        data,
        method: 'POST'
    })
}

// 完成审批任务
export function done(data) {
    return request({
        url: '/activiti-service/servicetask/task/complete',
        data,
        method: 'POST'
    })
}

// 完成任务前校验：下一节点是否为当前登录人的待办（needAutoConfirm=true 时弹窗询问是否自动审批）
export function checkAutoComplete(data) {
    return request({
        url: '/activiti-service/servicetask/task/autoComplete/check',
        data,
        method: 'POST'
    })
}

// 完成待阅的任务
export function read(data) {
    return request({
        url: '/activiti-service/activiti/task/notify/complete',
        data,
        method: 'post'
    })
}

// 暂存任务
export function storage(data) {
    return request({
        url: '/activiti-service/servicetask/task/tempsave',
        data,
        method: 'post'
    })
}

// // 已办审批任务取回功能
export function takeBackTask(data) {
    return request({
        url: '/activiti-service/servicetask/withdraw',
        data,
        method: "POST"
    })
}

// 校验已办任务能否取回：返回true可点击取回按钮，false按钮置灰
export function checkWithdraw(taskId) {
    return request({
        url: '/activiti-service/servicetask/withdraw/check?taskId=' + taskId,
        method: 'get'
    })
}

export function fetchLog(params) {
    return request({
        url: '/activiti-service/activiti/history/model?instanceId=' + params.instanceId
    })
}
// 加签查询
export function fetchSign(data) {
    return request({
        url: '/activiti-service/servicetask/sign/get',
         data,
        method: 'post',
    })
}

// 加签暂存
export function signStorage(data) {
    return request({
        url: '/activiti-service/servicetask/sign/add',
        data,
        method: 'post'
    })
}

// 加签提交
export function signSubmit(data) {
    return request({
        url: '/activiti-service/servicetask/sign/commit',
        data,
        method: 'post'
    })
}

// 获取审批类型
export function getCatagoryAll() {
    return request({
        url: '/common-service/sysreview/category/all',
    })
}

// 查询当前任务所在流程已走过的历史节点列表（跳转补审目标节点）
export function fetchJumpNodes(taskId) {
    return request({
        url: '/activiti-service/servicetask/task/jump/nodes?taskId=' + taskId,
        method: 'get'
    })
}

// 跳转到历史节点补审：direct-补审后返回当前节点，sequence-补审后按原流程顺序往下走
export function jumpToNode(data) {
    return request({
        url: '/activiti-service/servicetask/task/jump',
        data,
        method: 'post'
    })
}